function addProductDialog () {
  return {
    restrict: 'E',
    templateUrl: '/admin/dialogs/add-product/add-product.html?$$REVISION$$'
  }
}

export { addProductDialog }
